import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import bankingImg from "../../assets/bankingFinance.svg";

import { FaRobot, FaUniversity } from "react-icons/fa";

const styles = `
  .banking-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .banking-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .banking-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .banking-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .banking-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .banking-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .banking-header-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .banking-header-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .banking-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .banking-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .banking-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .banking-image-wrap {
    flex: 1;
  }

  .banking-image-wrap img {
    width: 100%;
    max-width: 650px;
  }

  .banking-accordion {
    flex: 1.2;
  }

  .accordion-item {
    margin-bottom: 18px;
  }

  .accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
  }

  .accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .banking-header {
      height: auto;
      min-height: 90px;
    }

    .banking-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .banking-header-title h2 {
      font-size: 22px;
    }

    .banking-header-triangle-left,
    .banking-header-triangle-right {
      width: 50px;
    }

    .banking-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Mobile landscape / small tablet (max-width: 768px) ── */
  @media (max-width: 768px) {
    .banking-header {
      flex-direction: column;
      height: auto;
    }

    .banking-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .banking-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .banking-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .banking-header-triangle-left,
    .banking-header-triangle-right {
      width: 40px;
    }

    .banking-header-title h2 {
      font-size: 18px;
    }

    .banking-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .banking-image-wrap {
      width: 100%;
      text-align: center;
    }

    .banking-image-wrap img {
      max-width: 100%;
    }

    .banking-accordion {
      width: 100%;
      flex: none;
    }

    .accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── Mobile portrait (max-width: 480px) ── */
  @media (max-width: 480px) {
    .banking-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .banking-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .banking-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .banking-header-right {
      height: 60px;
    }

    .banking-header-title h2 {
      font-size: 15px;
    }

    .banking-header-triangle-left,
    .banking-header-triangle-right {
      width: 28px;
    }

    .banking-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function BankingFinancePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.AI in fraud detection",
      content:
        "Machine learning algorithms can analyse thousands of data points in real-time and flag suspicious or fraudulent transactions."
    },
    {
      title: "2.Machine learning helps in investment",
      content:
        "AI technologies provide advanced market insights allowing fund managers to identify trends earlier."
    },
    {
      title: "3.Chatbots",
      content:
        "Chatbots in banking industry assist customers 24/7 with fast responses and support."
    },
    {
      title: "4.Mobile Apps Detects Fraud",
      content:
        "Banking apps detect risks and reduce fraudulent activities effectively."
    },
    {
      title: "5.Risk Management",
      content:
        "Helps in document verification, loan processing and financial risk control."
    },
    {
      title: "6.Data Collection & Analysis",
      content:
        "Mobile banking apps collect and analyze user data to improve experience."
    },
    {
      title: "7.Portfolio Management",
      content:
        "AI simplifies investment portfolio handling and recommendations."
    },
    {
      title: "8.Next-Level Security",
      content:
        "Ensures high-level security in banking operations."
    },
    {
      title: "9.Customization of services",
      content:
        "AI-powered apps provide personalized financial suggestions."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="banking-header">
        {/* LEFT */}
        <div
          className="banking-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="banking-header-overlay" />

          <div className="banking-header-badge">
            <div className="banking-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="banking-header-right">
          <div className="banking-header-triangle-left" />
          <div className="banking-header-triangle-right" />

          <div className="banking-header-title">
            <FaUniversity style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Banking and Finance</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="banking-main">
        {/* IMAGE */}
        <div className="banking-image-wrap">
          <img src={bankingImg} alt="Banking and finance" />
        </div>

        {/* ACCORDION */}
        <div className="banking-accordion">
          {data.map((item, i) => (
            <div key={i} className="accordion-item">
              <div
                className="accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span style={{ fontSize: "22px" }}>
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BankingFinancePage;
